import React, {
  useState,
  useEffect,
  Fragment,
  memo,
  useCallback,
  useRef,
} from "react";
import classNames from "classnames/bind";
import PropTypes from "prop-types";
import { Col, Row, Pagination, Toast, Loading } from "../../../../components";
import {
  MenuIcon,
  OffStatus,
  OnStatusGreen,
  TakePhotoIcon,
  WeakConnectStatus,
} from "../../../../components/Icons/Icons";
import VideoPlayer from "../VideoPlayer/VideoPlayer";
import styles from "./StreamCam.module.css";
import ReactPlayer from "react-player";
import { convertToSeconds } from "../../../../utils";
import { array_move, formatDDMMYY, returnArr } from "../../../../utils";
import { useStoreContext } from "../../../../hooks/useStoreContext";
import { PlayBackContext } from "../../../../contexts";
import image1 from "../../../../assets/images/novideo.png";
import image1En from "../../../../assets/images/novideo-en.png";
import { downloadVideo } from "../../../../utils";
import axios from "axios";
import SearchFail from "../../../Location/SearchFaild/SearchFail";
import { useScreenshot } from "use-react-screenshot";
import ProgressBar from "../../../../components/ProgressBar";
import { useTranslation } from "react-i18next";

const cx = classNames.bind(styles);

const StreamCam = ({
  streaming,
  screen,
  isFullScreen,
  page,
  getCodeInfo,
  getCodeSetting,
  setScreen,
  showModalDl,
  setShowModalDl,
}) => {
  const { hour, timeStart, count, currentPage, setCurrentPage } =
    React.useContext(PlayBackContext);
  const [listCamera, setListCamera] = useState([]);
  const [isOneCameraFullScreen, setIsOneCameraFullScreen] = useState(false);
  const [show, setShow] = useState(false);
  const [code, setCode] = useState();
  const [playing, setPlaying] = useState(false);
  const [oneCamera, setOneCamera] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const CancelToken = axios.CancelToken;
  const source = CancelToken.source();
  const { t } = useTranslation();
  const [downloadInfo, setDownloadInfo] = useState({
    progress: 0,
    completed: false,
    total: 0,
    loaded: 0,
    index: null,
    cancel: false,
  });
  const ref = React.useRef();
  const companyCode = sessionStorage.getItem("company_code");

  useEffect(() => {
    setCurrentPage(1);
  }, [screen]);
  React.useEffect(() => {
    if ((oneCamera.length > 0, oneCamera[0]?.time_start)) {
      ref?.current?.seekTo(
        convertToSeconds(hour) - convertToSeconds(oneCamera[0]?.time_start)
      );
    }
  }, [ref?.current, hour, oneCamera[0]?.url, isOneCameraFullScreen]);
  useEffect(() => {
    const timeOut = setTimeout(() => {
      setPlaying(true);
    }, 100);
    return () => timeOut;
  });
  useEffect(() => {
    console.log(streaming, screen);

    if (streaming.length > 0) {
      const data = streaming.filter((item, index) => {
        console.log(screen * (currentPage - 1), screen * currentPage);
        return (
          index + 1 > (currentPage - 1) * screen &&
          index + 1 <= screen * currentPage
        );
      });
      console.log(data, streaming);

      setListCamera(data);
    }
  }, [streaming, currentPage, screen]);

  const showOptions = (value) => {
    streaming.map((item) => {
      if (value === item?.code) {
        setShow(!show);
        setCode(value);
      }
      return item;
    });
  };

  const showInfoCamera = (code) => {
    getCodeInfo(code);
    setShow(!show);
  };

  const showSettingModal = (code) => {
    getCodeSetting(code);
    setShow(!show);
  };
  useEffect(() => {
    const clickOutSideToClose = (e) => {
      if (e.target.localName !== "svg") {
        setShow(false);
      }
    };
    document.addEventListener("click", clickOutSideToClose);
    return () => {
      document.removeEventListener("click", clickOutSideToClose);
    };
  }, [show]);

  const handleClick = (page) => {
    setCurrentPage(page);
  };

  const handleNext = () => {
    setCurrentPage(currentPage + 1);
  };

  const handlePrevious = () => {
    setCurrentPage(currentPage - 1);
  };

  const handleClose = () => {
    setIsLoading(false);
  };
  const renderStatus = useCallback((statusCode, companyCode) => {
    if (companyCode === "DEFAULT") {
      const status =
        statusCode === 0 || statusCode === undefined ? (
          <OnStatusGreen />
        ) : statusCode === 1 ? (
          <WeakConnectStatus />
        ) : statusCode === 2 ? (
          <WeakConnectStatus />
        ) : (
          <OffStatus />
        );
      return status;
    } else {
      const status = statusCode === 0 ? <OnStatusGreen /> : <OffStatus />;
      return status;
    }
  }, []);

  return (
    <>
      <div className={cx("live")}>
        <Row style={{ width: "100%" }} gap={[0, 0]}>
          {streaming && streaming.length > 0 ? (
            streaming.map((item, index) => {
              if (
                index < screen * currentPage &&
                index >= screen * (currentPage - 1) &&
                item?.code && screen !== 1
              ) {
                return (
                  <Col
                    style={{ position: "relative", background: "black" }}
                    key={index}
                    span={12 / Math.sqrt(screen)}
                  >
                    {item.status === "no-video" ? (
                      <img
                        src={
                          localStorage?.getItem("laguage") === "en"
                            ? image1En
                            : image1
                        }
                        alt={"sub"}
                        style={{
                          width: "100%",
                          height: "100%",
                        }}
                      />
                    ) : (
                      <VideoPlayer item={item} playing={playing} rerender={isFullScreen} />
                    )}
                    <div className={cx("setting")}>
                      <div
                        style={{ width: "50%" }}
                        className={cx("name_status")}
                      >
                        <span className={cx("On")}>
                          {renderStatus(item.stActive, companyCode)}
                        </span>

                        <span
                          style={{ fontSize: 12, maxWidth: "100%" }}
                          className={cx("name")}
                        >
                          {item?.name_cam}
                        </span>
                      </div>
                      <div className={cx("icon")}>
                        <span style={{ fontSize: 12, maxWidth: "100%" }}>
                          {formatDDMMYY(timeStart)} {hour}
                        </span>
                        <span
                          style={{ paddingTop: 8 }}
                          className={cx("menu")}
                          onClick={(e) => showOptions(item?.code)}
                        >
                          <MenuIcon />
                        </span>
                      </div>
                    </div>
                    {show && item.code === code && (
                      <div className={cx("options")}>
                        <ul className={cx("list")}>
                          <li
                            className={cx("item")}
                            onClick={() => showInfoCamera(item.code)}
                          >
                            {t("playback.infoCamera")}
                          </li>
                          <li
                            className={cx("item")}
                            onClick={() => showSettingModal(item.code)}
                          >
                            {t("playback.settingCamera")}
                          </li>
                          <li
                            className={cx("item")}
                            onClick={() => setShowModalDl(!showModalDl)}
                          >
                            {t("playback.downVideo")}
                          </li>
                        </ul>
                      </div>
                    )}
                  </Col>
                );
              } else if (screen === 1 && index ===0) {
                return (
                  <Col
                    style={{ position: "relative", background: "black" }}
                    key={index}
                    span={12 / Math.sqrt(screen)}
                  >
                    {item.status === "no-video" ? (
                      <img
                        src={
                          localStorage?.getItem("laguage") === "en"
                            ? image1En
                            : image1
                        }
                        alt={"sub"}
                        style={{
                          width: "100%",
                          height: "100%",
                        }}
                      />
                    ) : (
                      <VideoPlayer item={item} playing={playing} rerender={isFullScreen} />
                    )}
                    <div className={cx("setting")}>
                      <div
                        style={{ width: "50%" }}
                        className={cx("name_status")}
                      >
                        <span className={cx("On")}>
                          {renderStatus(item.stActive, companyCode)}
                        </span>

                        <span
                          style={{ fontSize: 12, maxWidth: "100%" }}
                          className={cx("name")}
                        >
                          {item?.name_cam}
                        </span>
                      </div>
                      <div className={cx("icon")}>
                        <span style={{ fontSize: 12, maxWidth: "100%" }}>
                          {formatDDMMYY(timeStart)} {hour}
                        </span>
                        <span
                          style={{ paddingTop: 8 }}
                          className={cx("menu")}
                          onClick={(e) => showOptions(item?.code)}
                        >
                          <MenuIcon />
                        </span>
                      </div>
                    </div>
                    {show && item.code === code && (
                      <div className={cx("options")}>
                        <ul className={cx("list")}>
                          <li
                            className={cx("item")}
                            onClick={() => showInfoCamera(item.code)}
                          >
                            {t("playback.infoCamera")}
                          </li>
                          <li
                            className={cx("item")}
                            onClick={() => showSettingModal(item.code)}
                          >
                            {t("playback.settingCamera")}
                          </li>
                          <li
                            className={cx("item")}
                            onClick={() => setShowModalDl(!showModalDl)}
                          >
                            {t("playback.downVideo")}
                          </li>
                        </ul>
                      </div>
                    )}
                  </Col>
                );
              } else {
                return <Fragment key={index} />;
              }
            })
          ) : (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                width: "100%",
              }}
            >
              <SearchFail title={t("playback.noCamera")} />
            </div>
          )}
        </Row>
      </div>
      <div className={cx("pagination", isFullScreen ? "full" : "")}>
        {streaming && streaming.length > 0 && streaming[0] ? (
          <Pagination
            onClick={handleClick}
            onNext={handleNext}
            onPrevious={handlePrevious}
            bgColor="rgba(255, 255, 255, 0.15)"
            pages={page}
            currentPage={currentPage}
            isFullScreen={isFullScreen}
          />
        ) : (
          <></>
        )}
      </div>
      {isLoading && (
        <ProgressBar
          data={downloadInfo}
          onClose={handleClose}
          handleCancel={source.cancel()}
        />
      )}
    </>
  );
};
StreamCam.propTypes = {
  screen: PropTypes.number.isRequired,
  isFullScreen: PropTypes.bool.isRequired,
  streaming: PropTypes.any.isRequired,
  setStreaming: PropTypes.any.isRequired,
  page: PropTypes.number.isRequired,
};
export default memo(StreamCam);
